// extracted by mini-css-extract-plugin
module.exports = {"ReportOfflineContainer":"_36U6j2ck","reportOffline":"aJ-iSi01","reportText":"_2m2OISvJ","reportFooter":"_11OOMUqR","reportPoweredBy":"_3g8ho324"};